import { render, staticRenderFns } from "./darkflow.vue?vue&type=template&id=2ed9753b&scoped=true&lang=pug&"
import script from "./darkflow.vue?vue&type=script&lang=js&"
export * from "./darkflow.vue?vue&type=script&lang=js&"
import style0 from "./darkflow.vue?vue&type=style&index=0&id=2ed9753b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed9753b",
  null
  
)

export default component.exports